<template>
  <section>
    <b-sidebar
      type="is-light"
      :fullheight="fullheight"
      :fullwidth="fullwidth"
      :overlay="overlay"
      :right="right"
      v-model="open"
      @close="toggleSidebar()"
    >
      <div class="admin-sidebar">
        <div class="figure">
          <img src="@/assets/images/logo.png" />
        </div>
        <b-menu class="p-1">
          <b-menu-list label="Usuarios">
            <b-menu-item
              icon="account-star"
              tag="router-link"
              :to="{ name: 'associates' }"
              @click.native="toggleSidebar"
              label="Socios"
            ></b-menu-item>
            <b-menu-item
              icon="account-tie"
              tag="router-link"
              :to="{ name: 'externals' }"
              @click.native="toggleSidebar"
              label="Externos"
            ></b-menu-item>
            <b-menu-item
              icon="account-hard-hat"
              tag="router-link"
              :to="{ name: 'administrators' }"
              @click.native="toggleSidebar"
              label="Administradores"
            ></b-menu-item>
          </b-menu-list>
          <b-menu-list label="Información">
            <b-menu-item
              icon="briefcase-clock"
              tag="router-link"
              :to="{ name: 'dashboard' }"
              @click.native="toggleSidebar"
              label="Dashboard"
            ></b-menu-item>
            <b-menu-item
              icon="calendar-range"
              tag="router-link"
              :to="{ name: 'meetings' }"
              @click.native="toggleSidebar"
              label="Reuniones"
            ></b-menu-item>
            <b-menu-item
              icon="handshake"
              tag="router-link"
              :to="{ name: 'interactions' }"
              @click.native="toggleSidebar"
              label="Interacciones"
            ></b-menu-item>
            <b-menu-item
              icon="chart-bar"
              tag="router-link"
              :to="{ name: 'statistics' }"
              @click.native="toggleSidebar"
              label="Estadísticas"
            ></b-menu-item>
          </b-menu-list>
          <b-menu-list label="Catalogos">
            <b-menu-item
              icon="account-circle"
              tag="router-link"
              :to="{ name: 'associated-turns' }"
              @click.native="toggleSidebar"
              label="Giros Socios"
            ></b-menu-item>
            <b-menu-item
              icon="account-circle-outline"
              tag="router-link"
              :to="{ name: 'external-turns' }"
              @click.native="toggleSidebar"
              label="Giros Externos"
            ></b-menu-item>
            <b-menu-item
              icon="account-convert-outline"
              tag="router-link"
              :to="{ name: 'circles' }"
              @click.native="toggleSidebar"
              label="Circulos"
            ></b-menu-item>
          </b-menu-list>
          <b-menu-list label="Opciones">
            <b-menu-item
              icon="cog"
              tag="router-link"
              :to="{ name: 'configurations' }"
              @click.native="toggleSidebar"
              label="Configuraciones"
            ></b-menu-item>
            <b-menu-item icon="logout" @click="logout" label="Salir"></b-menu-item>
          </b-menu-list>
        </b-menu>
      </div>
    </b-sidebar>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      open: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: false,
    };
  },
  computed: {
    ...mapState({
      menuOpen: (state) => state.ui.menuOpen,
    }),
  },
  watch: {
    menuOpen(newValue) {
      this.open = newValue;
    },
    open(newValue) {
      this.uiSetData({ key: 'menuOpen', data: newValue });
    },
  },
  methods: {
    ...mapMutations({
      uiSetData: 'ui/SET_DATA',
    }),
    toggleSidebar() {
      this.open = false;
    },
    logout() {
      Swal.fire({
        icon: 'info',
        title: 'Tu sesión ha sido cerrada correctamente.',
        confirmButtonColor: '#268af7',
      }).then(() => {
        // Eliminar todos los datos de sesión
        localStorage.removeItem('admin');
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminTokenTime');

        this.$router.push({ name: 'login' });
      });
    },
  },
};
</script>

<style lang="scss">
.admin-sidebar {
  .figure {
    padding: 20px 0;
    img {
      width: 60%;
      margin: auto;
      display: block;
    }
  }
}

.b-sidebar .sidebar-content.is-light {
  background-color: hsl(0deg 0% 100%) !important;
}
</style>
